import { useContext, useState } from 'react';
import AnimateHeight from 'react-animate-height';

import { BudgetMarketing, BudgetProductType } from 'types/api/budgets.type';

import { budgetDataService } from 'services/budget.service';

import { BudgetContext } from 'contexts';

import { checkParams } from 'helpers/checkParams';

import { BudgetListSkeleton } from 'pages/Budgets/components/Details/components/BudgetListSkeleton';
import { BudgetProduct } from 'pages/Budgets/components/Details/components/BudgetProduct';

import { Button } from 'components/Button';
import { Table } from 'components/Table';

import * as S from './Item.styles';
import { useColumns } from './columns.data';

type ItemProps = {
  data: BudgetMarketing;
};

export function Item(props: ItemProps): React.ReactElement {
  const { data } = props;

  const { params, date, addProducts } = useContext(BudgetContext);

  const [isSubListVisible, isSubListVisibleSet] = useState(false);
  const [isLoading, isLoadingSet] = useState<boolean>(false);
  const [productIds, productIdsSet] = useState<string[]>([]);

  const columns = useColumns(date);

  const getFabricProducts = () => {
    isSubListVisibleSet(!isSubListVisible);

    if (productIds.length === 0 && params && checkParams(params)) {
      isLoadingSet(true);

      budgetDataService.getProductMarketing(params, data.marketing).then((res) => {
        addProducts(res.data);
        const ids = res.data.map((item: BudgetProductType) => item.mainProduct.id);
        productIdsSet(ids);
        isLoadingSet(false);
      });
    } else {
      isSubListVisibleSet(!isSubListVisible);
    }
  };

  const childrenMapped = productIds.map((productId) => (
    <BudgetProduct key={productId} productId={productId} />
  ));

  return (
    <>
      <S.Container>
        <Button
          data-testid="plus-button"
          iconLeft={isSubListVisible ? 'FiMinus' : 'FiPlus'}
          onClick={() => getFabricProducts()}
        />

        <Table motive="budget" columns={columns} data={data ? [data] : []} />
      </S.Container>

      <AnimateHeight
        data-testid="sub-item-container"
        duration={500}
        height={isSubListVisible ? 'auto' : 0}
      >
        {isLoading ? <BudgetListSkeleton rows={2} /> : childrenMapped}
      </AnimateHeight>
    </>
  );
}
